export const DocumentValidationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.9873 4.677C9.9873 4.677 10.3206 5.01034 10.654 5.677C10.654 5.677 11.7128 4.01034 12.654 3.677"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66291 1.3476C4.99726 1.27708 3.71042 1.46896 3.71042 1.46896C2.89785 1.52706 1.34065 1.98261 1.34066 4.64307C1.34067 7.28091 1.32343 10.5329 1.34066 11.8293C1.34066 12.6214 1.83107 14.4689 3.52851 14.5679C5.59174 14.6883 9.30817 14.7139 11.0133 14.5679C11.4698 14.5422 12.9894 14.1838 13.1818 12.5304C13.381 10.8176 13.3414 9.62718 13.3414 9.34384"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6662 4.67708C14.6662 6.51803 13.1724 8.01044 11.3297 8.01044C9.48696 8.01044 7.99316 6.51803 7.99316 4.67708C7.99316 2.83614 9.48696 1.34375 11.3297 1.34375C13.1724 1.34375 14.6662 2.83614 14.6662 4.67708Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M4.65332 8.677H7.31997"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M4.65332 11.3438H9.98663"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
